import { render, staticRenderFns } from "./LevelBadge.vue?vue&type=template&id=4bd715c7&scoped=true"
import script from "./LevelBadge.vue?vue&type=script&lang=js"
export * from "./LevelBadge.vue?vue&type=script&lang=js"
import style0 from "./LevelBadge.vue?vue&type=style&index=0&id=4bd715c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd715c7",
  null
  
)

export default component.exports